import { useFormik, Form, FormikProvider } from 'formik';
import { Button } from 'styled';
import InputField from 'components/formik/InputField';
import Model from 'components/Modal';
import { getAllData, updateDocumentByID } from 'apis/customApiHandler';
import { useQuery, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { useCallback, useState } from 'react';
import ReactSelect from 'react-select';

const Edit = ({ handleClick, data, desable }) => {

  console.log('data--',typeof data.averageRunKmPerDay,data.averageRunKmPerDay);
  
  const [isDesable, setIsDesable] = useState(desable);
  const queryClient = useQueryClient();

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
  getAllData('/customer-fleet', {
    fromUsers: 1,
    limit: 3000,
  })
);

const { data: users } = useQuery(
  ['users'],
  () => getAllData('/user')
);

  const getUsersOptions = useCallback(() => {
    if (users && users.data && users.data.length) {
  // console.log(users.data.map((user) => user.name))
  return [
    ...users?.data?.map((user) => {
      return {
        value: user._id,
        label: user.name,
      };
    }),
  ]
  }
  },[users]);

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const formik = useFormik({
    initialValues: {
      fleetName: data.fleetName,
      fleetCode: data.fleetCode,
      agreedCPKM:  data.agreedCPKM,
      mappedFleets: data.mappedFleets,
      KAMs: data.KAMs,
      averageRunKmPerDay:data.averageRunKmPerDay,
      enableReplacementWithoutInspection: data.enableReplacementWithoutInspection,
      canCreateOrder: data.canCreateOrder,
      
    },
    onSubmit: async (values) => {
      await updateDocumentByID('customer-fleet', data._id, {
        fleetCode: values.fleetCode,
        agreedCPKM:  values.agreedCPKM,
        mappedFleets: values.mappedFleets,
        KAMs: values.KAMs,
        averageRunKmPerDay:parseInt(values.averageRunKmPerDay),
        enableReplacementWithoutInspection: values.enableReplacementWithoutInspection
      });
      toast.success('Successfully updated');
      queryClient.invalidateQueries('customer-fleet');
      handleClick();
    },

    validate: (values) => {
      let errors = {};
      if (!values.agreedCPKM) errors.agreedCPKM = 'Required';
      return errors;
    },
  });
  

  return (
    <Model
      handleClick={handleClick}
      title={`${desable ? 'View' : 'Edit'} CPKM`}
      className="max-w-2xl h-full overflow-hidden"
    >
      <div className="h-full overflow-auto">

     
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          <InputField
            type="text"
            label="Fleet Code"
            name="fleetCode"
            desable={true}
          />
          <InputField
            type="text"
            label="Fleet Name"
            name="fleetName"
            desable={true}
          />
          <InputField
            label="Agreed CPKM"
            name="agreedCPKM"
            type="number"
            desable={false}
            required = {true}
          />
          <label className="py-3 font-normal">
            Map to Fleets
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: 'transparent',
                  minWidth: '100%',
                  '&:hover': {
                    borderColor: 'rgb(34 197 94)',
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              isOptionDisabled={(option) =>
                option.value === data._id
              }
              value={
                formik.values.mappedFleets &&
                formik.values.mappedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: allFleets?.data?.find((item) => item._id === fleet)
                      ?.fleetName,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                console.log(value);

                  let selectedFleets = allFleets?.data?.filter((fleet) =>
                    value?.map((item) => item.value)?.includes(fleet._id)
                  );

                  formik.setFieldValue(
                    'mappedFleets',
                    value.map((fleet) => fleet.value)
                  );
              }}
              name="mappedFleets"
              isMulti={true}
            />
            {formik.touched.mappedFleets && formik.errors.mappedFleets ? (
              <p className="text-red-500 font-normal">
                *{formik.errors.mappedFleets}
              </p>
            ) : null}
          </label>
          <label className="py-3 font-normal">
            Map KAMs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: 'transparent',
                  minWidth: '100%',
                  '&:hover': {
                    borderColor: 'rgb(34 197 94)',
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getUsersOptions()}
              isOptionDisabled={(option) =>
                option.value === data._id
              }
              value={
                formik.values.KAMs &&
                formik.values.KAMs?.map((user) => {
                  return {
                    value: user,
                    label: users?.data?.find((item) => item._id === user)?.name,
                  };
                })
              }
              onChange={(value) => {
                  formik.setFieldValue(
                    'KAMs',
                    value.map((user) => user.value)
                  );
              }}
              name="KAMs"
              isMulti={true}
            />
            {formik.touched.KAMs && formik.errors.KAMs ? (
              <p className="text-red-500 font-normal">
                *{formik.errors.KAMs}
              </p>
            ) : null}
          </label>
          <InputField
            label="Average Run KM per day"
            name="averageRunKmPerDay"
            type="number"
            desable={false}
            step="1"
            min="0"
          />

        <div className="mt-3">
          <input 
              className="mx-3 w-[12px] h-[11px]"
              type="checkbox"
              id="enableReplacementWithoutInspection"
              name="enableReplacementWithoutInspection"
              checked={formik.values.enableReplacementWithoutInspection || false}
              onChange={(e) =>
              formik.setFieldValue('enableReplacementWithoutInspection', e.target.checked)
                }
            />
          <label className="text-gray-600 text-sm"
          htmlFor="enableReplacementWithoutInspection"
          >
            Enable Replacement Without Inspection
          </label>
          </div>

        </Form>
        {isDesable ? (
          <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button type="button" bgPrimary onClick={() => setIsDesable(false)}>
              Edit
            </Button>
          </div>
        ) : (
          <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button type="button" bgPrimary onClick={formik.handleSubmit}>
              Save Changes
            </Button>
          </div>
        )}
      </FormikProvider>
      </div>
    </Model>
  );
};

export default Edit;
